var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab',{attrs:{"index":this.tab,"loginRequired":this.loginRequired,"iframeDisplay":true,"init":_vm.init}})
}
var staticRenderFns = []

export { render, staticRenderFns }